import React from 'react';
import { useSelector } from "react-redux";
import { Redirect, Route } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ContextLoader } from '../ContextLoader';

const validUserAccess = (menu, permissionKey) => {
    const validPath = ({url, ns_children, children}) => {
        if (!!ns_children) return ns_children.some(validPath);
        if (!!children) return children.some(validPath);
        return url === permissionKey;
    };
    return menu.some(validPath);
};

const ProtectedRoute = ({ render, isProtected, permissionKey, ...rest }) => {
    const { data } = useSelector(({menu}) => ({ ...menu }));
    const renderComponent = (routeProps) => {
        const isAllowed = !isProtected || (!!isProtected && validUserAccess(data, permissionKey));
        if (isAllowed) return render(routeProps);

        toast.error('Você não tem permissão para acessar essa página.');
        return <Redirect to='/dashboard'/>;
    };

    return (
        <ContextLoader isLoading={false}>
            <Route {...rest} render={renderComponent} />
        </ContextLoader>
    );
}

export default ProtectedRoute;
  
